export default {
	data() {
		return {
			berthaBlockTypes: ['audio', 'video', 'textarea']
		};
	},
	computed: {
		aiGeneratedBlockTypes() {
			const selectedSlideBlocks = this.navigation.selectedSlide.blocks;

			const aiGeneratedBlockTypes = [];
			selectedSlideBlocks.forEach(block => {
				if (this.berthaBlockTypes.includes(block.type) && this.blockHasJobId(block.data)) {
					aiGeneratedBlockTypes.push(block.type);
				}
			});

			return [...new Set(aiGeneratedBlockTypes)];
		}
	},
	methods: {
		blockHasJobId(obj) {
			const key = Object.keys(obj).find(key => key.toLowerCase().includes('jobid'));
			if (!key) return false;

			return obj[key];
		}
	}
};
